import React from 'react';
import {Row, Col,Icon, Avatar} from "rsuite";
import './singleNews.style.sass';
import {Setting} from "../../setting";
import Pdf from "react-to-pdf";

class SingleNewsComponent extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            ref: ''
        }
    }


    componentDidMount() {
        const {news} = this.props;
        document.getElementById('news-description').innerHTML = news.description;
        this.setState({
            ref : React.createRef()
        })
    }
    render() {
        const {news} = this.props;
        return (
            <div className='single-news'>
                <div className='single-news-container'>
                    <img className='news-main-image' src={`${Setting.apiUrl}/${news.gallery[0].path}`}
                         alt='xitonix news'/>
                    <Row style={{maxWidth: "1000px", margin: 'auto'}}>
                        <Col xs={24} sm={24} md={19} >
                            <div className='news-main' ref={this.state.ref}>
                                <h2><Icon icon='circle'/> {news.title}</h2>
                                <p>
                                    {news.short_desc}
                                </p>
                                <div className='news-qute-box'>
                                    <h4>
                                        {news.quote}
                                    </h4>
                                    <div className='quote-box'>
                                        <Icon icon='quote-right'/>
                                    </div>
                                </div>
                                <div className='news-description'>
                                    {
                                        news.gallery.length > 1 ?
                                            <img className='news-sub-image'
                                                 src={`${Setting.apiUrl}/${news.gallery[1].path}`}
                                            /> : null
                                    }
                                        {/*{news.description}*/}
                                        <div id='news-description'/>
                                </div>
                                {/*<div className='news-download-div'>*/}
                                         {/*<a href='#' ><h5>دریافت نسخه pdf خبر - {news.title}</h5></a>*/}
                                {/*</div>*/}
                                {/*<Pdf targetRef={this.state.ref} filename="code-example.pdf">*/}
                                    {/*{({ toPdf }) => <button onClick={toPdf}>Generate Pdf</button>}*/}
                                {/*</Pdf>*/}
                            </div>
                        </Col>
                        <Col xs={24} sm={24} md={5}>
                            <div className='news-author-area'>
                                {
                                    news.avatar ?
                                        <Avatar circle src={`${Setting.apiUrl}${news.avatar}`}
                                                alt='xitonix news author' size="lg"/>
                                        :
                                        <Icon icon='avatar'/>
                                }
                                <h5><span>نویسنده : </span> {news.author}</h5>
                                {/*<div className='news-author-community'>*/}
                                {/*<Icon icon='instagram'/>*/}
                                {/*<Icon icon='whatsapp'/>*/}
                                {/*<Icon icon='envelope-o'/>*/}
                                {/*</div>*/}
                                <div className='news-read-time-div'>
                                    <Icon style={{fontSize: '20px', color: '#ef6600'}} icon='clock-o'/> <span> <span> زمان مطالعه : </span> <span>{news.read_time}دقیقه </span> </span>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
};

export default SingleNewsComponent;